module.exports = Object.freeze({
  CASES: 1,
  EMPLOYER: 2,
  EMPLOYER_UNAVAILABLE_BLOCK: 3,
});
